import React, { useState, useEffect } from 'react'
import Header from "components/Headers/Header.js";
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import axios from 'axios'
import { Card, CardHeader, CardBody, Container, Row, Col, Spinner, Button, Table, Modal, ModalHeader, ModalBody, ModalFooter, CardFooter } from "reactstrap";
import { format } from 'date-fns'; 
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import {Link} from 'react-router-dom'

function ListRequestInsurance() {

    const [loading, setLoading] = useState(true)
    const [insurance, setInsurance]=useState([])

    const [submitloadingaccept, setSubmitloadingaccept]=useState(true)
    const [submitloadingdelete, setSubmitloadingdelet]=useState(true)

    const [modalopenaccept, setModalopenaccept] = useState(false)

    const [modalreject, setModalreject] = useState(false)

    const [modaldelete, setModaldelete] = useState(false)

    const [modalMessage, setModalMessage]  = useState('')
        
    const token = useSelector((state) => state.userLogin.userInfo.token);

    ////////////
    const { t, i18n } = useTranslation();  

    useEffect(() => {
        const storedLanguage = localStorage.getItem('selectedLanguageAFS');
        if (storedLanguage) {
        i18n.changeLanguage(storedLanguage);
        }
    }, [i18n]);
    ////////////

    useEffect(() => {

        const fetchData = async () => {

            try {
                const config = {
                    headers: {
                        'Content-type': 'application/json',
                        Authorization: `Bearer ${token}`
                    }
                }
                
                const response = await axios.get(`${process.env.REACT_APP_BACKEND_API}/insurance/list-synchronization-insurance-operator/`, config);
                
                if (response.status===200) {

                    setInsurance(response.data)

                } else {

                }
                
            } catch (error) {
                
                console.log(error)

            } finally {
                setLoading(false)
            }
        };

        fetchData(); 
    }, [token]);

    const submitaccept = async(id) => {
        setSubmitloadingaccept(false);

        try {

            const config = {
                headers: {
                    'Content-type': 'application/json',
                    Authorization: `Bearer ${token}`
                }
            }
            
            await axios.get(`${process.env.REACT_APP_BACKEND_API}/insurance/accept-synchronization-insurance-operator/${id}/`, config);

        } catch(error) {
            console.log(error);
        } finally {
            setSubmitloadingaccept(true);
            setModalMessage(t('You have accepted the link'))
            setModalopenaccept(true)
        }
    }

    const submitdelete = async(id) => {
        setSubmitloadingdelet(false);

        try {

            const config = {
                headers: {
                    'Content-type': 'application/json',
                    Authorization: `Bearer ${token}`
                }
            }
            
            await axios.delete(`${process.env.REACT_APP_BACKEND_API}/insurance/reject-synchronization-insurance-operator/${id}/`, config);

        } catch(error) {
            console.log(error);
        } finally {
            setSubmitloadingdelet(true);
            setModalMessage(t('You have deleted the link'))
            setModaldelete(true)
        }
    }

    const submitreject = async(id) => {
        setSubmitloadingaccept(false); // Use the correct setter function

        try {
            const config = {
                headers: {
                    'Content-type': 'application/json',
                    Authorization: `Bearer ${token}`
                }
            }
            
            await axios.delete(`${process.env.REACT_APP_BACKEND_API}/insurance/reject-synchronization-insurance-operator/${id}/`, config);

        } catch(error) {
            console.log(error);
        } finally {
            setSubmitloadingaccept(true); // Use the correct setter function
            setModalMessage(t('You have rejected the link'))
            setModalreject(true)
        }
    }

    const modalrejectClose = async(e) => {
        window.location.reload();
    }

    const modalopenacceptClose = async(e) => {
        window.location.reload();
    }

    const modaldeleteClose = async(e) => {
        window.location.reload();
    }    

    return (
        <div>
            <Header/>
            {loading ? (
                <Container className="mt--15" fluid>
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-center mt-5">
                            <Spinner>
                                {t('Loading')}
                            </Spinner>
                        </Col>
                    </Row>
                </Container>
            ):(
                <Container className="mt--15" fluid>
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-center mt-5">
                            <Card className="shadow">
                                <CardHeader className="border-0">
                                    <h3>{t('Insurance Operator Link')}</h3>
                                </CardHeader>
                                <CardBody>
                                    {insurance.length>0 ? (
                                        <>
                                            <h5>{t('List of the available link')}</h5>
                                            <br></br>
                                            <Table
                                                className="align-items-center table-flush"
                                                responsive>
                                                <thead>
                                                    <tr>
                                                        <th>{t('First Name')}</th>
                                                        <th>{t('Last Name')}</th>
                                                        <th>{t('Email')}</th>
                                                        <th>{t('Accepted the link?')}</th>
                                                        <th>{t('Requested At')}</th> 
                                                        <th>{t('Action')}</th>                      
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {insurance.map((farmer, index) => (
                                                        <tr key={farmer.id}>
                                                            <td>{farmer.first_name_normal_user}</td>
                                                            <td>{farmer.last_name_normal_user}</td>
                                                            <td>{farmer.email_normal_user}</td>
                                                            <td>
                                                                {farmer.is_accepted ? (
                                                                    <FaCheckCircle color="green" />
                                                                ) : (
                                                                    <FaTimesCircle color="red" />
                                                                )}
                                                            </td>
                                                            <td>{format(new Date(farmer.created_at), 'PPpp')}</td>                                                        
                                                            <td>
                                                                {farmer.is_accepted ? (
                                                                    <>
                                                                        {submitloadingdelete ? (
                                                                            <Button color="danger" onClick={() => submitdelete(farmer.id)}>
                                                                                {t('Delete')} <i className="fas fa-trash"></i>
                                                                            </Button>
                                                                        ) : (
                                                                            <Button color="danger" disabled>
                                                                                <Spinner size="sm">
                                                                                    {t("Deleting the request...")}
                                                                                </Spinner>
                                                                                <span>{' '}{t("Deleting the request...")}</span>
                                                                            </Button>
                                                                        )}
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        {submitloadingaccept ? (
                                                                            <>
                                                                                <Button color="success" onClick={() => submitaccept(farmer.id)}>
                                                                                    {t('Accept')} <i className="fas fa-plus"></i>
                                                                                </Button>
                                                                                <Button color="danger" onClick={() => submitreject(farmer.id)}>
                                                                                    {t('Reject')} <i className="fas fa-minus"></i>
                                                                                </Button>
                                                                            </>
                                                                        ) : (
                                                                            <Button disabled>
                                                                                <Spinner size="sm">
                                                                                </Spinner>
                                                                            </Button>
                                                                        )}
                                                                    </>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        </>
                                        
                                    ):(
                                        <>
                                            <h5>{t('No operator insurance request received')}</h5>
                                        </>
                                    )}                                    
                                </CardBody>
                                <CardFooter>
                                    <Row>
                                        <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-center mt-2">
                                            <Link to="/">
                                                <Button color='primary'>
                                                    {t('Go back')} <i className="fas fa-rotate-left"></i>
                                                </Button>
                                            </Link>
                                        </Col>
                                    </Row>
                                </CardFooter>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            )}
            <Modal isOpen={modalopenaccept} toggle={modalopenaccept}>
                <ModalHeader >{t('Notification')}</ModalHeader>
                <ModalBody>
                    {modalMessage}
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={modalopenacceptClose}>{t('Close')}</Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={modaldelete} toggle={modaldelete}>
                <ModalHeader >{t('Notification')}</ModalHeader>
                <ModalBody>
                    {modalMessage}
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={modaldeleteClose}>{t('Close')}</Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={modalreject} toggle={modalreject}>
                <ModalHeader>{t('Notification')}</ModalHeader>
                <ModalBody>
                    {modalMessage}
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={modalrejectClose}>{t('Close')}</Button>
                </ModalFooter>
            </Modal>
        </div>
    )
}

export default ListRequestInsurance
